export default {
  BOTH: 'BOTH',
  UPPER: 'UPPER',
  LOWER: 'LOWER',
  SEPARATE: 'SEPARATE',
} as const
